module.exports = __webpack_public_path__ + "img/suzuki-nuevo-baleno.a538ad3f.png";